const cookieNotification = {
    message: 'Bu saytda cookies istifadə olunur',
    description: 'Daha ətraflı',
    button: 'Yaxşı',
};

export default cookieNotification;
